import React from 'react';

import PaginationButton from './PaginationButton';

type PaginationProps = {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  showItemsPerPageDropdown?: boolean;
};

const Pagination: React.FC<PaginationProps> = ({
  totalItems,
  currentPage,
  pageSize,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / pageSize);

  return (
    <div className="flex items-center justify-between py-2 gap-2">
      <div className="text-sm">
        Page {currentPage} of {totalPages}
      </div>

      <div className="flex items-center gap-2">
        <PaginationButton
          variant="ghost"
          size="icon"
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
        >
          «
        </PaginationButton>

        <PaginationButton
          variant="ghost"
          size="icon"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ‹
        </PaginationButton>

        <PaginationButton
          variant="ghost"
          size="icon"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages < 1}
        >
          ›
        </PaginationButton>

        <PaginationButton
          variant="ghost"
          size="icon"
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages || totalPages < 1}
        >
          »
        </PaginationButton>
      </div>
    </div>
  );
};

export { Pagination };
